import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { del } from "../../lib/request"

export const deleteAlertUser = createAsyncThunk(
  "alertUser/delete",
  async (userId, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const token = state.auth?.token

      if (!token) {
        throw new Error("Authentication required")
      }

      if (!userId) {
        throw new Error("User ID is required")
      }

      const endpoint = `alert-users/${userId}`

      await del(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      return { userId }
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to delete user")
    }
  }
)

const initialState = {
  status: "idle",
  error: null,
  deletedUserId: null,
}

const alertUserDeleteSlice = createSlice({
  name: "alertUserDelete",
  initialState,
  reducers: {
    clearDeleteUserError: (state) => {
      state.error = null
    },
    resetDeleteUserStatus: (state) => {
      state.status = "idle"
      state.error = null
      state.deletedUserId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteAlertUser.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(deleteAlertUser.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.deletedUserId = action.payload.userId
      })
      .addCase(deleteAlertUser.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const {
  clearDeleteUserError,
  resetDeleteUserStatus,
} = alertUserDeleteSlice.actions

export default alertUserDeleteSlice.reducer
